module.exports = __webpack_public_path__ + "static/img/pro-4-220x294.0154741.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pro-4-220x294.jpg
// module id = x3Wf
// module chunks = 1